module.exports = __webpack_public_path__ + "img/guanyu_04.ce42bc81.png";